<template>
    <div v-cloak>
        <b-btn
            :id="code+fieldName+enrolmentId"
            ref="button"
            :disabled="popoverShow"
            variant="outline-secondary"
            size="sm"
        >
            <span v-if="oldValue">
                {{ formatDate(oldValue) }}
            </span>
            <i
                v-else
                class="far fa-calendar-alt"
            />
        </b-btn>

        <b-popover
            ref="popover"
            :target="code+fieldName+enrolmentId"
            triggers="click"
            :show.sync="popoverShow"
            placement="auto"
            container="myContainer"
            @show="onShow"
            @hidden="onHidden"
        >
            <template slot="title">
                <b-btn
                    aria-label="Close"
                    class="close"
                    @click="onClose"
                >
                    <span
                        class="d-inline-block"
                        aria-hidden="true"
                    >
                        &times;
                    </span>
                </b-btn>
                {{ code }} - {{ description }}
            </template>

            <b-alert
                variant="danger"
                dismissible
                :show="error"
                @dismissed="showDismissibleAlert=false"
            >
                {{ description }} is required!
            </b-alert>

            <datepicker
                v-model="currentValue"
                format="dd/MM/yyyy"
                inline
                required
                :value="setInitialDate()"
                :disabled-dates="disabledDates ? disabledDates : { from: new Date() }"
            />

            <b-btn
                variant="danger"
                @click="onClose"
            >
                Cancel
            </b-btn>
            <b-btn
                :disabled="!currentValue"
                variant="primary"
                @click="onOk"
            >
                Save
            </b-btn>
        </b-popover>
    </div>
</template>

<script>
/* global Noty */
/* global moment */
/* global axios */
export default {
    name: 'EnrolmentDate',
    components: {},
    props: {
        enrolmentId: {
            type: Number,
            required: true,
        },
        code: {
            type: String,
            required: true,
        },
        fieldName: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        oldValue: {
            type: String,
            required: true,
        },
        disabledDates: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            actualSelectedLevels: [],
            popoverShow: false,
            currentValue: this.oldValue,
            error: false,
        };
    },
    watch: {
        currentValue() {
            if (this.currentValue) {
                this.error = false;
            }
        },
    },
    methods: {
        setLevels(levels) {
            this.actualSelectedLevels = levels;
        },
        setInitialDate() {
            const date = moment(this.oldValue);
            if (date.isValid()) {
                return new Date(date.year(), date.month(), date.date());
            }
            return '';
        },
        formatDate(date) {
            if (moment(date).isValid()) {
                return moment(date).format('DD/MM/YYYY');
            }
            return '-';
        },
        onClose() {
            this.popoverShow = false;
        },
        onHidden() {
            this.currentValue = this.oldValue;
            this.error = false;
        },
        onOk() {
            if (this.currentValue) {
                this.$nextTick(() => {
                    this.updateCurrentValue();
                });
                this.onClose();
            } else {
                this.error = true;
            }
        },
        onShow() {
            this.currentValue = this.oldValue;
        },
        updateCurrentValue() {
            this.isLoading = true;
            axios
                .patch(`/api/enrolmentsBulkUpdate/${this.enrolmentId}`, {
                    levels: this.actualSelectedLevels,
                    fieldName: this.fieldName,
                    currentValue: this.currentValue ? moment(this.currentValue).format('YYYY-MM-DD') : '',
                })
                .then(() => {
                    this.$emit('refreshData');
                    this.isLoading = false;

                    const n = new Noty({
                        text: `${this.description} updated!`,
                        type: 'success',
                        modal: false,
                    });
                    n.show();
                })
                .catch((error) => {
                    new Noty({
                        text: error.response.data.message,
                        type: 'error',
                        timeout: 1000,
                    }).show();
                });
        },
    },
};
</script>

<style>
    .popover {
        max-width: 325px !important;
    }
</style>
